<template>
  <FrHeader></FrHeader>
</template>

<script>
import FrHeader from "./big/FrHeader";

export default {
  name: "fr-head",
  components: {
    FrHeader,
  },
};
</script>

<style lang="less" scoped></style>
